package de.connect2x.timmy.customcomponents.roomHeaderWithArchiveButton

import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.size
import androidx.compose.foundation.layout.wrapContentHeight
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material.icons.Icons
import androidx.compose.material.icons.filled.Archive
import androidx.compose.material.icons.filled.DoorFront
import androidx.compose.material3.Badge
import androidx.compose.material3.BadgedBox
import androidx.compose.material3.Card
import androidx.compose.material3.HorizontalDivider
import androidx.compose.material3.Icon
import androidx.compose.material3.LocalAbsoluteTonalElevation
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.runtime.CompositionLocalProvider
import androidx.compose.runtime.collectAsState
import androidx.compose.runtime.mutableStateOf
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.semantics.Role
import androidx.compose.ui.semantics.role
import androidx.compose.ui.semantics.semantics
import androidx.compose.ui.semantics.text
import androidx.compose.ui.text.AnnotatedString
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.text.style.TextOverflow
import androidx.compose.ui.unit.dp
import androidx.compose.ui.window.Dialog
import de.connect2x.messenger.compose.view.DI
import de.connect2x.messenger.compose.view.common.Tooltip
import de.connect2x.messenger.compose.view.common.TooltipText
import de.connect2x.messenger.compose.view.common.UserState
import de.connect2x.messenger.compose.view.common.icons.PublicIcon
import de.connect2x.messenger.compose.view.common.icons.UnencryptedIcon
import de.connect2x.messenger.compose.view.common.modifier.minHeaderHeight
import de.connect2x.messenger.compose.view.get
import de.connect2x.messenger.compose.view.i18n.I18nView
import de.connect2x.messenger.compose.view.room.settings.ExportRoomContainer
import de.connect2x.messenger.compose.view.room.timeline.RoomBackButton
import de.connect2x.messenger.compose.view.room.timeline.RoomExtras
import de.connect2x.messenger.compose.view.room.timeline.RoomHeaderView
import de.connect2x.messenger.compose.view.room.timeline.RoomTopic
import de.connect2x.messenger.compose.view.room.timeline.UsersTyping
import de.connect2x.messenger.compose.view.theme.components
import de.connect2x.messenger.compose.view.theme.components.AvatarPresenceBadge
import de.connect2x.messenger.compose.view.theme.components.SurfaceStyle
import de.connect2x.messenger.compose.view.theme.components.ThemedButton
import de.connect2x.messenger.compose.view.theme.components.ThemedIconButton
import de.connect2x.messenger.compose.view.theme.components.ThemedLabel
import de.connect2x.messenger.compose.view.theme.components.ThemedSurface
import de.connect2x.messenger.compose.view.theme.components.ThemedUserAvatar
import de.connect2x.tim.compose.i18n.I18nTIMView
import de.connect2x.tim.compose.room.ExternalRoomMembersIcon
import de.connect2x.timmy.Constants
import de.connect2x.timmy.customcomponents.MatrixMessengerCustomSettings
import de.connect2x.timmy.customcomponents.customSettings
import de.connect2x.trixnity.messenger.MatrixMessengerSettingsHolder
import de.connect2x.trixnity.messenger.extensions.tim.roomdetails.TIMRoomHeaderViewModel
import de.connect2x.trixnity.messenger.update
import de.connect2x.trixnity.messenger.viewmodel.room.settings.ExportRoomViewModel
import de.connect2x.trixnity.messenger.viewmodel.room.settings.ExportRoomViewModelFactory
import de.connect2x.trixnity.messenger.viewmodel.room.timeline.RoomHeaderInfo
import de.connect2x.trixnity.messenger.viewmodel.room.timeline.RoomHeaderViewModel
import kotlinx.coroutines.CoroutineScope
import kotlinx.coroutines.Dispatchers
import kotlinx.coroutines.launch

class RoomHeaderViewWithArchiveButtonWcImpl : RoomHeaderView {
    private val showDialog = mutableStateOf(false)
    private val hintCheckBoxChecked = mutableStateOf(false)

    @Composable
    private fun fdsArchiveButton(roomHeaderViewModel: RoomHeaderViewModel) {
        val settingsHolder = DI.get<MatrixMessengerSettingsHolder>()
        val exportText = "Chatverlauf exportieren"
        val archiveButtonHintDisabled = settingsHolder.value.customSettings.archiveButtonHintDisabled
        if (roomHeaderViewModel is RoomHeaderWithArchiveButtonViewModelWcImpl) {
            Tooltip(
                { TooltipText(exportText) }
            ) {
                ThemedIconButton(
                    style = MaterialTheme.components.commonIconButton,
                    onClick = {
                        showDialog.value = !(archiveButtonHintDisabled ?: false)
                    }
                ) {
                    Icon(Icons.Default.Archive, exportText )
                }
            }
        }
    }

    // Completely Copied from TIMRoomHeader, except for the 'fdsArchiveButton';
    // needs to be updated if TIMRoomHeader changes
    @Composable
    override fun create(
        roomHeaderViewModel: RoomHeaderViewModel,
        showSettingsButton: Boolean,
        showBackButton: Boolean,
    ) {
        val roomHeaderElement = roomHeaderViewModel.roomHeaderInfo.collectAsState().value
        val usersTyping = roomHeaderViewModel.usersTyping.collectAsState().value
        val knockingMembersCount = roomHeaderViewModel.knockingMembersCount.collectAsState().value
        val i18n = DI.get<I18nView>()
        val hasExternalMembers = (roomHeaderViewModel is TIMRoomHeaderViewModel)
                && roomHeaderViewModel.hasExternalMembers.collectAsState().value

        if (roomHeaderViewModel is RoomHeaderWithArchiveButtonViewModelWcImpl) {
            val (viewModelContext, roomId) = roomHeaderViewModel.fetchViewModelContextAndRoomId()
            val exportRoomViewModelFactory = DI.get<ExportRoomViewModelFactory>()
            val exportRoomViewModel = exportRoomViewModelFactory.create(viewModelContext, roomId) {
                showDialog.value = false
            }

            when {
                showDialog.value -> { exportDialog(exportRoomViewModel) }
                hintCheckBoxChecked.value -> { saveHintSetting() }
            }
        }

        HeaderSurface {
            Column {
                Row(
                    horizontalArrangement = Arrangement.Center,
                    verticalAlignment = Alignment.CenterVertically,
                    modifier = Modifier.minHeaderHeight()
                ) {
                    if (showBackButton) {
                        Spacer(Modifier.size(8.dp))
                        RoomBackButton(roomHeaderViewModel)
                    }

                    Row(
                        Modifier
                            .padding(vertical = 4.dp)
                            .align(Alignment.CenterVertically)
                            .fillMaxWidth()
                            .weight(1f, true),
                        verticalAlignment = Alignment.CenterVertically,
                    ) {
                        Spacer(Modifier.size(8.dp))
                        ThemedButton(
                            style = MaterialTheme.components.accountSelector,
                            onClick = { roomHeaderViewModel.openRoomSettings() },
                            modifier = Modifier.semantics(mergeDescendants = true) {}
                        ) {
                            Row(
                                horizontalArrangement = Arrangement.Start,
                                verticalAlignment = Alignment.CenterVertically,
                                modifier = Modifier.semantics {
                                    text = AnnotatedString(roomHeaderElement.roomName)
                                    role = Role.Button
                                }
                            ) {
                                Box {
                                    ThemedUserAvatar(
                                        initials = roomHeaderElement.roomImageInitials,
                                        image = roomHeaderElement.roomImage,
                                        presence = roomHeaderElement.presence
                                    ) {
                                        AvatarPresenceBadge(roomHeaderElement.presence)
                                    }
                                    if (roomHeaderElement.isPublic) {
                                        PublicIcon()
                                    }
                                }
                                Spacer(Modifier.size(5.dp))
                                UserState(roomHeaderViewModel.userTrustLevel, roomHeaderViewModel.isUserBlocked)
                                if (roomHeaderElement.isEncrypted.not()) {
                                    UnencryptedIcon()
                                    Spacer(Modifier.size(5.dp))
                                }
                                if (knockingMembersCount > 0) {
                                    ThemedIconButton(
                                        style = MaterialTheme.components.commonIconButton,
                                        onClick = { roomHeaderViewModel.openRoomSettings() }
                                    ) {
                                        BadgedBox(
                                            badge = {
                                                Badge {
                                                    Text("$knockingMembersCount")
                                                }
                                            }
                                        ) {
                                            Icon(
                                                Icons.Default.DoorFront,
                                                i18n.roomHeaderKnockingUsersCount(knockingMembersCount),
                                            )
                                        }
                                    }
                                    Spacer(Modifier.size(5.dp))
                                }
                                Column(modifier = Modifier.padding(end = 14.dp)) {
                                    Row(verticalAlignment = Alignment.CenterVertically) {
                                        RoomName(roomHeaderElement, hasExternalMembers)
                                        Spacer(Modifier.size(7.dp))
                                        if (roomHeaderElement.isLeave) {
                                            ThemedLabel(i18n.commonArchived())
                                        }
                                    }
                                    if (usersTyping != null) {
                                        UsersTyping(usersTyping)
                                    } else {
                                        RoomTopic(roomHeaderElement)
                                    }
                                }
                            }
                        }

                        // Extra spacer and archive button, added by us
                        Spacer(Modifier.weight(1f))
                        if (Constants.ARCHIVE_BUTTON_ENABLED) {
                            fdsArchiveButton(roomHeaderViewModel)
                        }
                    }

                    RoomExtras(roomHeaderViewModel, showSettingsButton)
                    Spacer(Modifier.size(8.dp))

                }
                HorizontalDivider(Modifier.fillMaxWidth())
            }
        }
    }

    @Composable
    fun exportDialog(exportRoomViewModel: ExportRoomViewModel) {
        Dialog(onDismissRequest = { }) {
            Card(
                modifier = Modifier
                    .fillMaxWidth()
                    .wrapContentHeight(unbounded = true)
                    .padding(16.dp),
                shape = RoundedCornerShape(16.dp),
            ) {
                ExportRoomContainer(exportRoomViewModel)
            }
        }
    }


    @Composable
    private fun saveHintSetting() {
        val settingsHolder = DI.get<MatrixMessengerSettingsHolder>()
        CoroutineScope(Dispatchers.Default).launch {
            settingsHolder.update<MatrixMessengerCustomSettings> {
                it.copy(archiveButtonHintDisabled = hintCheckBoxChecked.value)
            }
        }
    }

    @Composable
    fun RoomName(
        roomHeaderElement: RoomHeaderInfo,
        hasExternalMembers: Boolean,
    ) {
        val i18n = DI.current.get<I18nTIMView>()
        Row {
            Tooltip({ Text(roomHeaderElement.roomName) }) {
                Text(
                    roomHeaderElement.roomName,
                    style = MaterialTheme.typography.titleMedium,
                    fontWeight = FontWeight.Bold,
                    overflow = TextOverflow.Ellipsis,
                    maxLines = 1
                )
            }
            if (hasExternalMembers) ExternalRoomMembersIcon(
                tooltipText = i18n.externalRoomMembersTooltipInHeader(),
            )
        }
    }

    @Composable
    private fun HeaderSurface(
        style: SurfaceStyle = MaterialTheme.components.header,
        content: @Composable () -> Unit,
    ) {
        val localElevation = LocalAbsoluteTonalElevation.current

        CompositionLocalProvider(
            LocalAbsoluteTonalElevation provides 0.dp
        ) {
            ThemedSurface(
                style = style,
                modifier = Modifier.fillMaxWidth(),
            ) {
                CompositionLocalProvider(
                    LocalAbsoluteTonalElevation provides LocalAbsoluteTonalElevation.current + localElevation
                ) {
                    content()
                }
            }
        }
    }

}
